/**
 * SPA virtualPageview — once per completed route change (not on first load).
 * Avoids double GA4 page_view: initial hit comes from GTM Google tag.
 */

import { trackVirtualPageview } from "./dataLayer";

let initialized = false;
let lastPath = null;
let timer = null;

function currentPathKey() {
  return `${window.location.pathname}${window.location.search}`;
}

function schedulePush() {
  const next = currentPathKey();
  if (next === lastPath) return;
  if (timer) clearTimeout(timer);
  // Defer so React can update document.title after navigation.
  timer = setTimeout(() => {
    const path = currentPathKey();
    if (path === lastPath) return;
    lastPath = path;
    trackVirtualPageview({
      page_path: path,
      page_location: window.location.href,
      page_title: document.title || "",
    });
  }, 120);
}

/**
 * Patch history once. Safe to call from App; no-op if already inited
 * or if blade already installed window.__vlvVirtualPageviewInit.
 */
export function initSpaVirtualPageview() {
  if (typeof window === "undefined") return;
  if (initialized || window.__vlvVirtualPageviewInit) return;
  initialized = true;
  window.__vlvVirtualPageviewInit = true;

  lastPath = currentPathKey();

  const hist = window.history;
  const _ps = hist.pushState;
  const _rs = hist.replaceState;
  hist.pushState = function pushStatePatched() {
    const r = _ps.apply(this, arguments);
    schedulePush();
    return r;
  };
  hist.replaceState = function replaceStatePatched() {
    const r = _rs.apply(this, arguments);
    schedulePush();
    return r;
  };
  window.addEventListener("popstate", schedulePush);
}
